import { useCallback, useId, useRef, useState } from "react";
import { reviewDiffAccessibility } from "@workerstation/shared";
import type { DiffEditorHandle } from "./diff-editor-io.ts";
import type { CodeDiffEditorProps } from "./diff-model.ts";
import { useDiffEditor } from "./react.tsx";
export type { CodeDiffEditorMode, CodeDiffSnapshot } from "./diff-model.ts";

export function CodeDiffEditor({ candidateId, original, modified, mode, active = true, revealLine, onMount }: CodeDiffEditorProps) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const onMountRef = useRef(onMount);
  onMountRef.current = onMount;
  const mounted = useCallback((editor: DiffEditorHandle) => onMountRef.current?.(editor), []);
  const accessibilityId = useId();
  const accessibility = reviewDiffAccessibility(mode, modified.path);
  const error = useDiffEditor(container, accessibilityId, { candidateId, original, modified, mode, active, revealLine, label: accessibility.label }, mounted);
  return <div role="region" aria-label={accessibility.label} aria-describedby={accessibilityId} className="relative h-full min-h-[380px] w-full">
    <p id={accessibilityId} className="sr-only">{accessibility.instructions}</p>
    <div ref={setContainer} className="absolute inset-0" />
    {error ? <div role="alert" className="absolute inset-x-3 top-3 z-10 rounded border border-status-error bg-kumo-base p-3 text-xs text-status-error">{error}</div> : null}
  </div>;
}
